import classNames from "classnames";
import { useParams } from "react-router";
import { Mentionable } from "../../../../../../common/sesh_types";
import { DashboardUtils } from "../../../dashboard_utils";
import { useGuildMemberQuery } from "../hooks/use_guild_members";
import { WithTooltip } from "../tooltips/with_tooltip";

export default function SimpleMemberDisplayName(props: {
	user_id: string;
	include_discriminator?: boolean;
	include_avatar?: boolean;
	width?: 16 | 24 | 32;
}) {
	const { server_id } = useParams<{ server_id: string }>();
	const members_query = useGuildMemberQuery(server_id, [props.user_id]);

	const member = members_query?.members?.find(
		(val) => val.id === props.user_id
	);

	return <SimpleMemberDisplayNameWithoutCache member={member} {...props} />;
}

export function SimpleMemberDisplayNameWithoutCache(props: {
	member: Mentionable;
	user_id: string;
	include_discriminator?: boolean;
	include_avatar?: boolean;
	width?: 16 | 24 | 32;
}) {
	const { member } = props;

	const has_valid_discriminator =
		member?.discriminator && member.discriminator !== "0";

	return (
		<>
			{props.include_avatar && (
				<span className="mr-1 inline-block align-text-bottom">
					<figure
						className={classNames("image flex-shrink-0", {
							"is-16x16": props.width === 16,
							"is-24x24": !props.width || props.width === 24,
							"is-32x32": props.width === 32,
						})}
					>
						<img
							className="is-rounded"
							src={
								member?.avatar_url
									? `https://cdn.discordapp.com/${member.avatar_url}`
									: DashboardUtils.GetPlaceholderAvatarURL(
											props.user_id,
											32
									  )
							}
							width={props.width ?? 24}
							height={props.width ?? 24}
						/>
					</figure>
				</span>
			)}
			{member ? (
				<>
					{member.name}
					{has_valid_discriminator && (
						// Add slight right padding so italic isnt cut off
						<span className="pr-[2px] italic">
							#{member.discriminator}
						</span>
					)}
				</>
			) : (
				props.user_id
			)}
		</>
	);
}
